module.exports = __webpack_public_path__ + "school/img/theoryBg.aa373551.jpg";